import type { FaireProductEntity } from "../../entity_types/product";

export const p_zkfru6ned5: FaireProductEntity = {
  token: "p_zkfru6ned5",
  type: "product",
  name: "You betcha, we love it here Minnesota Silhouette Wood Sign",
  brandName: "SAWDUST CITY",
  imageUrl:
    "https://cdn.faire.com/fastly/2036d2978d832f0fb0a0af64b281eb4ee7ee75da9a3856adac047a1a814fbdbb.jpeg",
  priceDollars: 8,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/952d1aea46a43c7fcec2ef4c76b5d275490d2dccd4752cf3166470c9cbe883ac.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
